import ToggleSlider from 'components/ToggleSlider';
import ToggleButton from 'components/buttons/ToggleButton';
import ToggleContainer from 'components/containers/ToggleContainer';
import ToggleOptionsContainer from 'components/containers/ToggleOptionsContainer';

import { MAX_SINGLE_ROW_OPTIONS, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const Toggle: FunctionComponent<Props> = ({
    activeIndex,
    className = '',
    isDisabled = false,
    onClick,
    options,
    testId = TEST_ID
}) => {
    const wrappedClass = options.length > MAX_SINGLE_ROW_OPTIONS ? styles.wrapped : '';

    const slider =
        activeIndex === undefined ? null : (
            <ToggleSlider activeIndex={activeIndex} optionCount={options.length} />
        );

    return (
        <ToggleContainer className={`${className} ${wrappedClass}`} testId={testId}>
            {slider}

            <ToggleOptionsContainer>
                {options.map(({ label, value }, index) => {
                    const activeClass = index === activeIndex ? styles.toggleButtonActive : '';

                    return (
                        <ToggleButton
                            className={`${styles.toggleButton} ${activeClass}`}
                            isActive={index === activeIndex}
                            isDisabled={isDisabled}
                            key={`${value}-${index}`}
                            onClick={() => onClick(value)}
                            text={label}
                        />
                    );
                })}
            </ToggleOptionsContainer>
        </ToggleContainer>
    );
};

export default Toggle;
